// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabs_tabContainer__+It9d","tabActive":"tabs_tabActive__BQ5zm"};